import React from 'react';

const JobDetailsModal = ({ job, onClose }) => {
    if (!job) return null;

    return (
        <div className="job-modal-overlay" onClick={onClose}>
            <div className="job-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="job-modal-close" onClick={onClose}>&times;</button>

                <div className="job-modal-header">
                    <h3 className="job-modal-title">{job.title}</h3>
                    <p className="job-modal-location"><i className="fa fa-map-marker"></i> {job.location}</p>
                    <p className="job-modal-deadline"><i className="fa fa-calendar"></i> Deadline: {job.deadline}</p>
                </div>

                <div className="job-modal-body">
                    <div className="job-section">
                        <h4>Key Responsibilities</h4>
                        <ul>
                            {job.responsibilities.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>

                    <div className="job-section">
                        <h4>Qualifications & Requirements</h4>
                        <ul>
                            {job.requirements.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="job-modal-footer">
                    <p>Interested applicants should send their CV/Resume to:</p>
                    <a
                        href={`mailto:${job.email}?subject=Application for ${job.title}`}
                        className="ht-btn ht-btn--default"
                    >
                        Apply Now
                    </a>
                </div>
            </div>
        </div>
    );
};

export default JobDetailsModal;
